import { render, staticRenderFns } from "./NoRealQueryListPage.vue?vue&type=template&id=d25c6210&"
import script from "./NoRealQueryListPage.vue?vue&type=script&lang=js&"
export * from "./NoRealQueryListPage.vue?vue&type=script&lang=js&"
import style0 from "./NoRealQueryListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports